import { render } from "./index.vue?vue&type=template&id=5315fb4d"
const script = {}

import exportComponent from "/Users/demigodliu/src/packages/cumen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__